import filesServices from "api/filesAPI";
import React from "react";
import { FileIcon, defaultStyles } from "react-file-icon";
import { AiFillDelete } from "react-icons/ai";
import Swal from "sweetalert2";
const CaseFile = ({
  fileName,
  caseNumber,
  caseId,
  caseFiles,
  setCaseFiles,
  readOnly,
}) => {
  const type = fileName.substring(fileName.lastIndexOf(".") + 1);
  const name = fileName.substring(0, fileName.lastIndexOf("."));
  const urlPath =
    process.env.NODE_ENV === "development"
      ? "https://192.168.1.135/CasesFiles/"
      : "https://uis.diaeldin.com/CasesFiles/";
  const handleDelete = async () => {
    const alertResult = Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      background: "#2b3445",
      color: "#fff",

      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if ((await alertResult).isConfirmed) {
      const result = await filesServices.del(caseId);
      if (result.ok) {
        const filter = caseFiles.filter((file) => file.id !== caseId);
        setCaseFiles(filter);
        console.log(caseId);
        return;
      }
      Swal.fire({
        title: "Error",
        text: "Something went wrong",
        icon: "error",
        background: "#2b3445",
        color: "#fff",

        showConfirmButton: false,
        timer: 1500,
      });
    }
  };
  return (
    <div>
      <div className="flex justify-between">
        <a
          href={`${urlPath}${caseNumber}/${fileName}`}
          target="_blank"
          rel="noreferrer"
        >
          <div className="w-8 h-8 my-3">
            <FileIcon extension={type} {...defaultStyles[type]} />
          </div>
        </a>
        {!readOnly && (
          <button>
            <AiFillDelete
              className="w-10 h-10 px-2 rounded-lg text-red-400/80 hover:bg-red-400 hover:text-slate-300"
              onClick={handleDelete}
            />
          </button>
        )}
      </div>
      <span>{name}</span>
    </div>
  );
};

export default CaseFile;
